module.exports = __webpack_public_path__ + "img/produkcja.32f2f924.png";